import React, { useState, useEffect, useRef } from "react";
import { useSelector, shallowEqual } from "react-redux";
import Portal from "../portal";
import { FiX } from "react-icons/fi";
import { toast } from "react-toastify";
import axios from "axios";
import { url } from "../../apis/constant";

const AddHomepageBanner = ({ title, getApi }) => {
  const adminToken = localStorage.getItem("wed_admin_token");
  const [isSubmit, setIsSubmit] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const [hrefValue, setHrefValue] = useState("");
  const [altValue, setAltValue] = useState("");
  const [orderValue, setOrderValue] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);

  const { palettes } = useSelector(
    (state) => ({
      palettes: state.palettes,
    }),
    shallowEqual
  );
  let { background } = { ...palettes };

  const modalRef = useRef(null);
  const [open, setOpen] = useState(false);
  const show = () => setOpen(true);
  const hide = () => {
    setOpen(false);
    setNameValue("");
    setHrefValue("");
    setAltValue("");
    setOrderValue(0);
    setSelectedFile(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!modalRef || !modalRef.current) return false;
      if (!open || modalRef.current.contains(event.target)) return false;
      setOpen(!open);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open, modalRef]);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleBanner = () => {
    setIsSubmit(true);
    if (!nameValue) {
      toast.error("Title is required");
      setIsSubmit(false);
      return;
    }

    const formData = new FormData();
    formData.append("title", nameValue);
    formData.append("href", hrefValue);
    formData.append("alt", altValue);
    formData.append("order", orderValue);
    if (selectedFile) {
      formData.append("image", selectedFile);
    }

    axios
      .post(url + "/admin/homepage-banner", formData, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          toast.success(res.data.message);
          hide();
          setIsSubmit(false);
          getApi(100, 1);
        } else {
          toast.error(res.data.message);
          setIsSubmit(false);
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response?.data?.message || "Error occurred");
      });
  };

  return (
    <>
      <button
        className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white addCategoryCss"
        type="button"
        onClick={show}
      >
        Add Banner
      </button>
      {open && (
        <Portal selector="#portal">
          <div className="modal-backdrop fade-in"></div>
          <div className={`modal show ${background === "dark" ? "dark-mode" : ""}`} data-background={background}>
            <div className="relative min-w-sm w-auto mx-auto lg:max-w-5xl" ref={modalRef}>
              <div className="modal-content">
                <div className="modal-header">
                  <h3 className="text-xl font-semibold">{title}</h3>
                  <button className="modal-close btn btn-transparent" onClick={hide}>
                    <FiX size={18} className="stroke-current" />
                  </button>
                </div>
                <div className="relative p-4 flex-auto">
                  <label>Title:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Enter Title"
                      value={nameValue}
                      onChange={(e) => setNameValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Link (href):</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Enter Link"
                      value={hrefValue}
                      onChange={(e) => setHrefValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Alt Text:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="text"
                      placeholder="Enter Alt Text"
                      value={altValue}
                      onChange={(e) => setAltValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Order:</label>
                  <div className="inputBoxCategoryCss">
                    <input
                      type="number"
                      placeholder="Enter Order"
                      value={orderValue}
                      onChange={(e) => setOrderValue(e.target.value)}
                      className="inputFields"
                    />
                  </div>
                  <label className="mt-3 block">Image:</label>
                  <div className="inputBoxCategoryCss">
                    <input type="file" accept="image/*" onChange={handleFileChange} className="inputFields" />
                  </div>
                </div>
                <div className="modal-footer space-x-2">
                  <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button" onClick={hide}>
                    Close
                  </button>
                  {isSubmit ? (
                    <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button">
                      Loading...
                    </button>
                  ) : (
                    <button className="btn btn-default btn-rounded bg-blue-500 hover:bg-blue-600 text-white" type="button" onClick={handleBanner}>
                      Save Changes
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default AddHomepageBanner;